export const requiredField = value => value && value?.trim?.() !== "" ? undefined : "Поле обязательно"
export const minValue = value => value && value < 150 ? "Минимум 150мм" : undefined
export const maxCircleValue = value => value && value > 2000 ? "Максимум 2м (2000мм)" : undefined
export const maxValue = value => value && value > 3200 ? "Максимум 3.2м (3200мм)" : undefined
